export const CommonResources = {
  state: {
    sectionsList: [],
  },

  getters: {
    commonGetSectionsList: (state) => {
      return state.sectionsList;
    },
  },

  mutations: {
    commonSetSectionsList(state, sectionsList) {
      state.sectionsList = sectionsList;
    },
  },
  actions: {
    async commonRequestSectionsList(ctx) {
      let response = await this._vm.$api('api.get.sections', { version: '1.0' });
      ctx.commit('commonSetSectionsList', response.data.data);
    },
  },
};
